<div>
  <span style="font-size: 16px; color: #333">
    请拖动滑块，使拼图与缺口对齐
  </span>
</div>

<div style="width: fit-content; margin-top: 8px">
  <app-image-checker
    [width]="data?.bgWidth || 350"
    [height]="data?.bgHeight || 200"
    [imageBase64]="data?.imageBase64"
    [tileBase64]="data?.tileBase64"
    [tileY]="data?.tileY || 0"
    [tileW]="data?.tileW || 55"
    [tileH]="data?.tileH || 52"
    (positionChange)="onSliderXChanged($event)"
    (dragEnd)="onDragEnd($event)"
  ></app-image-checker>

  <div
    style="
      margin-top: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <button
      mat-icon-button
      color="primary"
      (click)="reset()"
      title="刷新验证码"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</div>
